module.exports = __webpack_public_path__ + "img/tg.c7ce18f7.svg";